export interface NavbarState {
    sidebarActivated: boolean;
    scrollNavActivated: boolean;
}

export const INITIAL_NAVBAR_STATE: NavbarState = {
    sidebarActivated: false,
    scrollNavActivated: false,
};
